// Progressive enhancement for ltl-facets: submit the sort menu on change (the form already
// works without JavaScript, including a visible Apply button, which is hidden here).
(() => {
  document.querySelectorAll('[data-facets]').forEach((root) => {
    const select = root.querySelector('[data-facets-sort]');
    const fallback = root.querySelector('[data-facets-sort-submit]');
    if (!select) return;
    if (fallback) fallback.hidden = true;
    select.addEventListener('change', () => select.form.submit());
  });
})();
